import { UserGroupForm } from "../../../components/user-group/UserGroupForm";
import { useAddUserGroup } from "@/hooks/users/useAddUserGroup";
import { useNavigate, useLocation } from "react-router-dom";

const AddUserGroup = () => {
  const { addUserGroup, loading } = useAddUserGroup();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (data: any) => {
    try {
      await addUserGroup({
        userGroupName: data.groupName,
        userIds: data.assignedUsers.map((user: any) => user.id),
      });
      
      // Preserve filters and tab when returning
      const returnParams = location.state?.returnParams || '';
      const activeTab = location.state?.activeTab || 'user-group';
      navigate(`/admin/users?${returnParams}`, {
        state: { activeTab }
      });
    } catch (error) {
      // Error is handled in the hook
    }
  };

  return (
    <UserGroupForm
      title="Add New User Group"
      onSubmit={handleSubmit}
      isSubmitting={loading}
    />
  );
};

export default AddUserGroup;